/**
 * Frontend logging utility service.
 * Provides centralized logging with consistent interface and future extensibility.
 */
export class LoggingUtility {
  private readonly console: typeof console;

  constructor(consoleInstance: typeof console = console) {
    this.console = consoleInstance;
  }

  /**
   * Logs informational messages.
   * @param args - Any number of arguments, same as console.log
   */
  log(...args: unknown[]): void {
    this.console.log(...args);
  }

  /**
   * Logs error messages.
   * @param args - Any number of arguments, same as console.error
   */
  error(...args: unknown[]): void {
    this.console.error(...args);
  }

  /**
   * Logs warning messages.
   * @param args - Any number of arguments, same as console.warn
   */
  warn(...args: unknown[]): void {
    this.console.warn(...args);
  }

  /**
   * Logs debug messages.
   * @param args - Any number of arguments, same as console.debug
   */
  debug(...args: unknown[]): void {
    this.console.debug(...args);
  }
}

// Create and export a singleton instance
export const loggingUtility = new LoggingUtility();
